import ajax from './axios.config'

// 全局构造函数
// 应用方法 new Date(里面写时间).fromat("yyyy-MM-dd")
Date.prototype.format = function (fmt) {
    var o = {
        "y+": this.getFullYear(), //年份
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
/**
 * 字符串截取后面加入...
 *
 * @author ADCannon
 * @date 2021/07/16
 * @param {Number} len 指定开始截取的长度
 * @return {*} 截取后的字符串
 */
String.prototype.interceptString = function (len) {
    if (this.length > len) {
        return this.substring(0, len) + "...";
    } else {
        return this;
    }
}

/**
 * 将一个字符串用给定的字符变成数组
 *
 * @author ADCannon
 * @date 2021/07/16
 * @param {String} tag 指定的字符串
 * @return {Array} 处理后的数组
 */
String.prototype.toArray = function (tag) {
    if (this.indexOf(tag) != -1) {
        return this.split(tag);
    } else {
        if (this != '') {
            return [this.toString()];
        } else {
            return [];
        }
    }
}

/**
 * 数组对象排序
 *
 * @author ADCannon
 * @date 2021/07/16
 * @param {string} [rule='ASC'] ASC正序  DESC倒序 默认正序排序
 * @param {string} [key=""] 需要排序的key，如不需要可不传或传""
 * @return {Array} 返回排序后的数组
 */
Array.prototype.arrSort = function (rule = 'ASC', key = "") {
    if (this.length > 0) {
        this.sort((x, y) => {
            switch (rule) {
                case "ASC":
                    if (key != "") {
                        return x[key] - y[key];
                    } else {
                        return x - y;
                    }
                    case "DESC":
                        if (key != "") {
                            return y[key] - x[key];
                        } else {
                            return y - x;
                        }

                        default:
                            return;
            }
        });
        return this;
    } else {
        return this;
    }
}

const utils = {
    /**
     * @description: 本地存储相关
     * @author: ADCannon
     * @date: 2021-07-16 11:54:31
     * @version: V1.0.0
     */
    storage: {
        get: function (str) {
            let Getitem = localStorage.getItem(str);
            if (Getitem) {
                if (JSON.parse(Getitem).data) {
                    return JSON.parse(Getitem).data;
                } else {
                    return JSON.parse(Getitem)
                }
            } else {
                return null;
            }

        },
        set: function (str, data) {
            localStorage.setItem(str, JSON.stringify(data))
        },
        remove: function (str) {
            localStorage.removeItem(str);
        }
    },

    /**
     * @description: 获取与设置cookie
     * @author: ADCannon
     * @date: 2021-07-16 11:54:43
     * @version: V1.0.0
     */
    cookie: function (key, value, options) {
        // 未传递 value 参数，则表示读取 cookie
        if (typeof value === "undefined") {
            // 将域下所有 cookie 读取出来，以 "; " 分割保存到数组中
            var cookies = document.cookie.split("; ");
            // 遍历迭代所有的 cookie ，查找指定 key 对应的 cookie 值
            for (var i = 0, len = cookies.length; i < len; i++) {
                // 将当前遍历到的 cookie 使用 "=" 分割
                var parts = cookies[i].split("=");
                // 数组中第一个元素为 cookie 名，将 cookie 名解码
                var name = decodeURIComponent(parts.shift());
                // 判断当前 cookie 名与待查找 cookie 的名称是否一致
                if (name === key) // 找到 cookie，则返回对应 cookie 值
                    return decodeURIComponent(parts.join("="));
            }

            // 如果循环迭代完毕所有 cookie 都不存在要查找的 cookie 信息，则说明未保存过
            return undefined;
        }

        // 传递了 value 参数，表示保存 cookie
        // "key=value"，将 key 和 value 编码
        var _cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value);
        // 判断可配置选项
        options = options || {};
        if (options.expires) { // 有失效时间的配置
            var date = new Date();
            date.setDate(date.getDate() + options.expires);
            _cookie += ";expires=" + date.toUTCString();
        }
        if (options.path) // 有配置路径
            _cookie += ";path=" + options.path;
        if (options.domain) // 域
            _cookie += ";domain=" + options.domain;
        if (options.secure) // 安全链接
            _cookie += ";secure";
        // 保存 cookie
        document.cookie = _cookie;
    },
    /**
     * @description: 删除cookie
     * @author: ADCannon
     * @date: 2021-07-16 11:54:55
     * @version: V1.0.0
     */
    removeCookie(key, options) {
        options = options || {};
        options.expires = -1;
        utils.cookie(key, "", options);
    },
    getUserId() {
        if (utils.cookie("UserCookie")) {
            return JSON.parse(decodeURIComponent(utils.cookie("UserCookie"))).userid;
        } else {
            return "0";
        }
    },
    // 浏览器UA判断相关
    browser: {
        /**
         * @description: 是否移动端
         * @author: ADCannon
         * @date: 2021-07-16 11:55:16
         * @version: V1.0.0
         */
        IsMobile: function () {
            let info = navigator.userAgent;
            let agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod", "iPad"];
            for (let i = 0; i < agents.length; i++) {
                if (info.indexOf(agents[i]) >= 0) return true;
            }
            return false;
        },
        /**
         * @description: 是否微信内打开
         * @author: ADCannon
         * @date: 2021-07-16 11:55:35
         * @version: V1.0.0
         */
        isWeiXin: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @description: 是否支付宝内打开
         * @author: ADCannon
         * @date: 2021-07-16 11:55:53
         * @version: V1.0.0
         */
        isAlipay: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/Alipay/i) == "alipay") {
                return true;
            } else {
                return false;
            }
        },
        /**
         * @description: 是否iOS系统
         * @author: ADCannon
         * @date: 2021-07-16 11:58:12
         * @version: V1.0.0
         */
        isiOS: function () {
            var u = navigator.userAgent;
            return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        },
        /**
         * @description: 是否Android系统
         * @author: ADCannon
         * @date: 2021-07-16 11:58:12
         * @version: V1.0.0
         */
        isAndroid: function () {
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
            return isAndroid;
        }
    },
    urlParam(url, params) {
        let keys = Object.keys(params)
        let strArr = url.split('/')
        let result = ''
        strArr.forEach(i => {
            if (i[0] === ':') {
                keys.forEach(j => {
                    if (j === i.substring(1, i.length)) {
                        i = params[j].toString()
                    }
                })
            }
            result += i + '/'
        })
        return result.substring(0, result.length - 1)
    },
    creatApi(options) {
        // let _this = this;
        let result = {};
        let funNames = Object.keys(options);
        funNames.forEach(name => {
            result[name] = obj => {
                const method = options[name][0];
                let url = options[name][1];
                if (obj) {
                    url = this.urlParam(url, obj);
                }
                return ajax[method](url, obj);
            }
        });
        return result;
    },
    /**
     * @description: 获取页面指定参数
     * @author: ADCannon
     * @date: 2021-07-16 11:59:54
     * @version: V1.0.0
     */
    getQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(unescape(r[2]));
        return null;
    },
    /**
     * App内打开新页面跳转
     *
     * @author ADCannon
     * @date 2021/07/16
     * @param {String} Url 需要跳转的Url
     * @param {Object} [param={}] 跳转需要携带的参数
     */
    openWithNewWindow: function (Url, param = {}) {
        let a = document.createElement("a");
        if (Object.keys(param).length > 0) {
            Object.keys(param).forEach(key => {
                Url.indexOf("?") != -1 ? Url += `&${key}=${encodeURIComponent(param[key])}` : Url += `?${key}=${encodeURIComponent(param[key])}`;
            });
        }
        let InGSApp = "";
        if (utils.getQueryString("InGSApp")) {
            InGSApp = "&InGSApp=true";
        }
        Url.indexOf("?") != -1 ? Url += "&gsAppOpenWithNewWindow=true" + InGSApp : Url += "?gsAppOpenWithNewWindow=true" + InGSApp
        // a.target = "_blank";
        a.href = Url;
        a.click();
        a.remove();
    },
    loginTimer: function () {
        if (!utils.cookie("UserCookie")) {
            window.LoginTimer = window.setInterval(() => {
                if (utils.browser.isiOS()) {
                    if (utils.cookie("UserCookie")) {
                        window.clearInterval(window.LoginTimer);
                        window.LoginTimer = null;
                        location.reload();
                    }
                } else {
                    // GSAppFunc.getCurrentUserInfo(function (userInfo) {
                    //     if (userInfo.id != '') {
                    //         window.clearInterval(window.LoginTimer);
                    //         window.LoginTimer = null;
                    //         GSAppFunc.exit();
                    //     }
                    // });
                }
            }, 500);
        }
    },
    /**
     * 正则替换字符串中所有的项
     *
     * @author ADCannon
     * @date 2021/07/16
     * @param {String} str 原始字符串
     * @param {String} oldSep 需要替换的字符串
     * @param {String} newSep 需要替换成的字符串
     * @return {String} 替换后的字符串
     */
    replaceAll: function (str, oldSep, newSep) {
        if (str == "" || str == null || str == undefined) {
            return str;
        }
        var reg = new RegExp(oldSep, "g"); // g,表示全部替换。
        return str.replace(reg, newSep);
    },
    // 时间差
    getEndTime(timestamp) {
        let nowTime = new Date().getTime();
        let endTIme = new Date(timestamp).getTime() + 1000 * 60 * 60 * 8;
        let diffTime = parseInt(endTIme - nowTime);
        let days = Math.floor(diffTime / 1000 / 60 / 60 / 24);
        let hours = Math.floor(diffTime / 1000 / 60 / 60 - (24 * days));
        let minutes = Math.floor(diffTime / 1000 / 60 - (24 * 60 * days) - (60 * hours));

        if (nowTime > endTIme) {
            return false;
        }

        if (days > 0) {
            return `${days}天`;
        } else if (hours > 0) {
            return `${hours}小时`;
        } else if (minutes > 0) {
            return `${minutes}分钟`;
        } else {
            return "0分钟";
        }
    },
    // 判断当前运行环境是否为GSApp内置浏览器
    isInAppWebView() {
        let _isInAppWebView = 0;
        if (utils.getQueryString("InGSApp")) {
            _isInAppWebView = 5;
        } else if (window.navigator.userAgent != null &&
            window.navigator.userAgent.indexOf("GSApp/") >= 0) {
            _isInAppWebView = 6;
        }
        return _isInAppWebView;
    },
    h5OpenDraw() {
        let a = document.createElement('a');
        let url = window.location.href;
        if (!!location.search) {
            url = url
        } else {
            url = url
        }
        a.href = `https://a.gamersky.com/app/url?url=${encodeURIComponent(url) }&cmsStatisticsId=0`;
        if (utils.browser.isAndroid()) {
            a.href = `gamersky://a.gamersky.com/app/url?url=${encodeURIComponent(url)}&cmsStatisticsId=0`;
            setTimeout(() => {
                let down = document.createElement('a');
                down.href = 'https://wap.gamersky.com/app/download.html?ios=8z4bKf&android=ObumKD';
                down.target = '_blank';
                down.click();
                down.remove();
            }, 300)
        }
        a.target = '_blank';
        a.click();
        a.remove();
    },
}

export default utils;